var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row-info" }, [
        _c("div", { staticClass: "row-info-title" }, [
          _vm._v(" 产品信息 "),
          this.infoData.publish_status == "未发布"
            ? _c("span", { staticClass: "edit-icon-div" }, [
                _c("img", {
                  staticClass: "width-full",
                  attrs: {
                    src: require("../../assets/img/buttonedit.svg"),
                    alt: "",
                  },
                  on: { click: _vm.showUpdataProductModel },
                }),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("产品名称："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.product_name)),
          ]),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("创建时间："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.created_at_str)),
          ]),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("产品KEY："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.product_key)),
          ]),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("认证方式："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.auth_style)),
          ]),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("产品类型："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.product_type)),
          ]),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("连接类型："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.link_type)),
          ]),
        ]),
        _c("div", { staticClass: "row-info-contant" }, [
          _c("span", { staticClass: "row-info-contant-title" }, [
            _vm._v("状态："),
          ]),
          _c("span", { staticClass: "row-info-contant-contant" }, [
            _vm._v(_vm._s(_vm.infoData.publish_status)),
          ]),
        ]),
        _vm.infoData.sub_product
          ? _c("div", { staticClass: "row-info-contant" }, [
              _c("span", { staticClass: "row-info-contant-title" }, [
                _vm._v("子设备默认产品："),
              ]),
              _c("span", { staticClass: "row-info-contant-contant" }, [
                _vm._v(_vm._s(_vm.infoData.sub_product)),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("UpdataProduct", {
        ref: "UpdataProduct",
        attrs: {
          showInputDialog: _vm.UpdataProductloading,
          infoData: _vm.updataData,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.UpdataProductloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.UpdataProductloading = $event
          },
          getData: _vm.getData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }